import React, { Component } from 'react'
import {Button, Form, FormGroup, Label, Input, FormFeedback, NavLink} from 'reactstrap';
import { connect } from 'react-redux';
import { firebase } from '../utils/firebase';
import { addUser, addAnimal } from '../redux/actions';
import { FirestoreDocument } from 'react-firestore';
import Checkout from '../checkout';

import 'react-image-crop/dist/ReactCrop.css'
import imageCompression from 'browser-image-compression';
// First way to import
import { BarLoader } from 'react-spinners';


const mapStateToProps = state => {
  const { user } = state;
  return {
    user,
  }
}



const mapDispatchToProps = dispatch => {
  return {
    onAddUserClick: user => {
      dispatch(addUser(user))
    },
    onAddAnimalClick: animal => {
      dispatch(addAnimal(animal))
    }
  }
};
const Step1 = props => (
  <div>
    {props.pageLoading? 
    <div className="CenterImage">
    <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/>
     </div>
     :
    <Form>
      <h4>Order Your Tag!</h4>
      <br />
      <FormGroup>
        <Input type="select" name="accountCreationType" onChange={props.onHandleChange}>
          <option value='newAccount'>Create an account and order a new tag</option>
          <option value='createUserProfile'>Create a profile to transfer an existing tag to</option>
          <option value='addingNewAnimal'>Create a new tag for your existing account</option>
          <option value='editProfile'>Edit your existing tags</option>
        </Input>
      </FormGroup>
      {
        //this case if for editing the profile selection
        props.accountCreationType === 'editProfile' ?
          <NavLink href="/login" className="justify-content-center">Click here to login</NavLink>
          :
          <div>
                  
            <FormGroup>
            <label>( * Required)</label>                  
            <br />
              <Input type="email" name="email" maxLength="50" id="exampleEmail" placeholder="Email *" onChange={props.onHandleChange} invalid={props.authStatus} />
              <FormFeedback invalid>{(props.accountCreationType === 'newAccount' || props.accountCreationType ==='createUserProfile') ? <div>Oops! That email is already attached to another account</div> : <div>Invalid username or password</div>}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Input type="password" name="password" id="examplePassword" placeholder="Password *" onChange={props.onHandleChange} invalid={(props.accountCreationType === 'newAccount' || props.accountCreationType === 'createUserProfile') ? props.invalidPassword : false} />
              <FormFeedback invalid>Password is weak! Needs to be more than 6 characters and cannot be "password"</FormFeedback>
            </FormGroup>
            {props.accountCreationType === 'addingNewAnimal' ?
                        <NavLink justify="true" href="/passwordReset" className="justify-content-center">Forgot password?</NavLink>
                        : null
            }
            {(props.accountCreationType === 'newAccount' || props.accountCreationType === 'createUserProfile') ?
              <FormGroup>
                <Input type="password" name="password2" id="examplePassword2" placeholder="Re-enter Password *" onChange={props.onHandleChange} invalid={(props.accountCreationType === 'newAccount' || props.accountCreationType === 'createUserProfile') ? props.invalidPassword2 : false} />
                <FormFeedback invalid>Passwords do not match!</FormFeedback>
              </FormGroup> : null
            }
            <div className="CenterImage">
              <br></br>
              <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={props.isLoadingSomething} />

            </div>
          </div>
      }
    </Form>
    }
  </div>
)
export const Step2 = props => (
  <Form>

    <h1>Animal Owner</h1>
    <br/>
    <label>( * Required)</label>   
    <br />               
    <FormGroup>
      <Input type="text" name="firstName" id="firstname" defaultValue={props.editForm ? props.firstName : props.firstName} placeholder="First Name *" onChange={props.onHandleChange} /> 
      <Input type="text" name="lastName" id="lastName" defaultValue={props.editForm ? props.lastName : props.lastName} placeholder="Last Name *" onChange={props.onHandleChange} />
    </FormGroup>
    <FormGroup>
      <Input type="text" name="line1" id="exampleAddress" defaultValue={props.editForm ? props.address.line1 : props.line1} placeholder='Street Address *' onChange={props.onHandleChange} />
      <Input type="text" name="line2" id="exampleAddress" defaultValue={props.editForm ? props.address.line2 : props.line2} placeholder="Apartment, Suite, Unit, etc." onChange={props.onHandleChange} />
      <Input type="text" name="city" id="exampleAddress" defaultValue={props.editForm ? props.address.city : props.city} placeholder="City *" onChange={props.onHandleChange} />
      <Input type="text" name="state" id="exampleAddress" defaultValue={props.editForm ? props.address.state : props.state} placeholder="State/Province/Region *" onChange={props.onHandleChange} />
    </FormGroup>
    <FormGroup>
      <Input type="number" name="zip" id="zip" defaultValue={props.editForm ? props.address.zip : props.zip} placeholder="Zip Code *" onChange={props.onHandleChange} invalid={props.invalidZipLength} />
      <FormFeedback invalid>Zip code has to be 5 digits</FormFeedback>
    </FormGroup>
    <FormGroup>
      <Input type="text" name="country" id="exampleAddress" defaultValue={props.editForm ? props.address.country : props.country} placeholder="Country *" onChange={props.onHandleChange} />
    </FormGroup>

    <FormGroup>
      <Input type="text" maxLength="10" minLength="10" pattern="[0-9]*" name="phoneNumberPrimary" id="phoneNumberPrimary" defaultValue={props.editForm ? props.phoneNumberPrimary : props.phoneNumberPrimary} placeholder="Phone Number *" onChange={props.onHandleChange} invalid={props.phoneNumberValidLongChars || props.phoneNumberTooShortIndicator} />
      {props.phoneNumberValidLongChars ? <FormFeedback invalid> The phone number must be 10 digits and not contain any special characters such as -,+,(,), or spaces </FormFeedback> : <FormFeedback invalid> The phone number must be 10 digits long </FormFeedback>}
    </FormGroup>
    <FormGroup>

      <br/>

    </FormGroup>
    <FormGroup className="profileUploadBlock">
    <Label onClick={() => alert('This is a photograph of you- the animal owner! You\'ll have a chance to upload a photograph of your animal momentarily. This picture can be changed in the future by logging in to your profile, so no worries if you don\'t have your favorite picture with you right now.')}
          > Upload a profile picture. {'\u24d8'}</Label>
      {
        (props.profilePictureBlob === null) ? null : <img className="imagePreview" src={props.profilePictureBlob} alt="Preview of Image" />
      }
      <input type="file" name="profilePicture" id="centerFileUpload" accept=".jpg, .png" onChange={props.handleProfileUploadCompression} />
    </FormGroup>

    {
      props.editForm ? null : <div>
        <FormGroup>
          <input type="checkbox" name="agreeToPrivacy" id="agreeToPrivacy" defaultChecked={props.agreeToPrivacy} onChange={props.onHandleChange} zoom="2"></input>
          By checking the box, you agree to the <a style={{color:"#37B349"}} href="https://verfidpet.com/privacy-policy" target="_blank">Terms </a> 
          and
          <a style={{color:"#37B349"}} href="https://verfidpet.com/privacy-policy" target="_blank"> Privacy Policy</a>
          .
        </FormGroup></div>
    }

    </Form>
);
const Step4 = props => (

  <div className="checkoutStep">
    <br></br>
    {props.userPaidLogic ?
      <div>
        <h5>Thank you for your payment.</h5>
        <h5>Click the submit button to finish making your tag.</h5>
      </div>
      : <div className="beforeSuccessfulPayment">
        <h1>Payment</h1>
        <br></br>
        <h3>Total Price: ${(props.amountSet / 100).toFixed(2)}</h3>
        <br></br>
        <div>
          <FormGroup>
            <Input type="text" name="referral" id="referral" placeholder="Referred by (optional)" defaultValue={null} onChange={props.onHandleChange} />
          </FormGroup>
          <FormGroup>
            <Input type="text" name="promoCode" id="promoCode" placeholder="Gift code or Promo code (optional)" onChange={props.onHandleChange} />
            <br></br>
            {(props.promoCode === null || props.promoCode === "") ? null :
              <Button onClick={props.checkPromoCode}>Submit Promo Code</Button>
            }
          </FormGroup>
        </div>


        <Label onClick={() => alert('This fee includes shipping, programming the custom tag, and taxes.')} >Shipping and Processing {'\u24d8'}</Label>
        <Input type="select" name="shippingType" id="shippingType" onChange={props.onHandleChange}>
          <option value='standard'>Standard- $2.95 (5-7 days)</option>
          <option value='expedited'>Expedited- $7.95 (1-3 days)</option>
        </Input>


        <br></br>

        <Checkout
          amount={props.amountSet}
          description={"Purchase of a VERFID tag"}
          userId={props.userID}
          onSuccess={() => props.userPaid()}
          email={props.email}
        />
        <br></br>

      </div>}
  </div>

);
export const Step3 = props => (

  <Form>
    <h1>Animal Information</h1>
    <br/>
    
    <h3>General Information</h3>
    <label>( * Required)</label>                  
    <br/>
    {props.editForm ? null : 
    <FormGroup>
      <Input type="select" name="animalType" onChange={props.onHandleChange} defaultValue={props.animalType}>
        <option value='canine'>Dog</option>
        <option value='feline'>Cat</option>
      </Input>
    </FormGroup>
    }
    <FormGroup>
      <Input type="text" name="animalName" id="animalName" placeholder="Name *" defaultValue={props.editForm ? props.name : props.animalName} onChange={props.onHandleChange} />
    </FormGroup>
    <FormGroup>
      <Input type="number" name="weight" id="weight" maxLength="3" max="200" min="0" placeholder="Weight (lbs) *" defaultValue={props.editForm ? props.weight : props.weight} onChange={props.onHandleChange} />
    </FormGroup>
    
     
          <Label for="ownership">Animal Date of Birth *</Label>
          <FormGroup style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
            <Input type="date" name="animalBirthDate" defaultValue={props.editForm ? props.birthDateFormatted : props.animalBirthDate} onChange={props.onHandleChange} invalid={(!props.datesInFuture || props.editForm) ? false : true} />
            <FormFeedback invalid>Date indicated must be before today.</FormFeedback>
          </FormGroup>
          <Label for="ownership">Date of Ownership *</Label>
          <FormGroup style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
            <Input type="date" name="ownershipDate" defaultValue={props.editForm ? props.ownedSinceFormatted : props.ownershipDate} onChange={props.onHandleChange} invalid={(props.datesInOrder || props.editForm) ? false : true} />
            <FormFeedback invalid>Date of ownership must be after date of birth</FormFeedback>
          </FormGroup>
    
     
        <FormGroup>
          <Label for="gender">Animal Gender</Label>
          <Input type="select" name="gender" onChange={props.onHandleChange} defaultValue={props.gender}>
            <option value='Male'>Male</option>
            <option value='Female'>Female</option>
          </Input>
        </FormGroup>
    
    
        <FormGroup>
          <Label for="breedType">Primary Animal Breed</Label>
          <FirestoreDocument
            path={`breeds/${props.animalType}`}
            render={({ isLoading, data }) => {
              const breeds = isLoading ? null : data.data;
              return isLoading ? (
                <option>Loading</option>) : (
                  <Input type="select" name="breed" id="exampleSelect" defaultValue={props.breed} onChange={props.onHandleChange}>
                    {breeds.map(breed => {
                      return <option>{breed}</option>
                    })}
                  </Input>
                )
            }}
          />
        </FormGroup>
    
  
        <FormGroup>
          <Label onClick={() => alert('Select Not Applicable if you have a Purebred')}
          > Secondary Animal Breed {'\u24d8'}</Label>
          <FirestoreDocument
            path={`breeds/${props.animalType}`}
            render={({ isLoading, data }) => {
              const breeds = isLoading ? null : data.data;
              return isLoading ? (
                <option>Loading</option>) : (
                  <Input type="select" name="breed2" defaultValue={props.breed2 === "Not Applicable" ? "Not Applicable" : props.breed2} id="exampleSelect" placeholder="Not Applicable" onChange={props.onHandleChange}>
                    {breeds.map(breed2 => {
                      return <option>{breed2}</option>
                    })}
                  </Input>
                )
            }}
          />
        </FormGroup>
    
    <br/>
    <br/>
    <h3>Health Information</h3>
    <FormGroup>
      <Label for="fixed">Is your animal fixed?</Label>
      <Input type="select" name="fixed" onChange={props.onHandleChange} defaultValue={props.editForm ? props.fixed : props.fixed}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
    </FormGroup>
    {
          (props.fixed === false || props.fixed === "false") ?
            null :
            <div>
              <FormGroup>
              <Label onClick={() => alert('Don\'t have proof of Spay or Neuter with you? No problem, these files can be uploaded later. Your tag will not display this until the files are submitted and verified.')}
              > Upload proof of Spay or Neuter {'\u24d8'}</Label>
              <input id="centerFileUpload" type="file" accept=".pdf, .jpg, .png" name="fileSN" onChange={props.handleProfileUploadCompression} />
            </FormGroup>
            </div>
    }

<FormGroup>
      <Label for="vetHealthCert">Do you have a Veterinarian Health Certificate?</Label>
      <Input type="select" name="vetHealthCert" onChange={props.onHandleChange} defaultValue={props.vetHealthCert}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
    </FormGroup>
    {(props.vetHealthCert === false || props.vetHealthCert === "false") ?
      null : <FormGroup className="profileUploadBlock">
        <Label>Veterinary Health Certificate Issue Date</Label>       
        <Input type="date" name="VetHealthIssueDate"  onChange={props.onHandleChange} defaultValue={props.VetHealthIssueDate} />
        <Label>Veterinary Health Certificate Expiration Date</Label>       
        <Input type="date" name="VetHealthExpirationDate"  onChange={props.onHandleChange} defaultValue={props.VetHealthExpirationDate} />
        <Label for="veterinaryHealthCertificate">Upload Veterinary Health Certificate</Label>
        <input type="file" name="veterinaryHealthCertificate" id="centerFileUpload" accept=".jpg, .png, .pdf" onChange={props.handleProfileUploadCompression} />
    </FormGroup>
    }

<FormGroup>
      <Label for="fecalExam1">Has your animal passed a fecal exam?</Label>
      <Input type="select" name="fecalExam" onChange={props.onHandleChange} defaultValue={props.fecalExam}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
    </FormGroup>
    {(props.fecalExam === false || props.fecalExam === "false") ?
      null : <FormGroup className="profileUploadBlock">
        <Label>Fecal Exam Expiration Date</Label>       
        <Input type="date" name="FecalExamExpirationDate"  onChange={props.onHandleChange} defaultValue={props.FecalExamExpirationDate} />
        <Label for="fecal Exam">Upload proof of the fecal exam</Label>
        <input type="file" name="fecalExamCertificate" id="centerFileUpload" accept=".jpg, .png, .pdf" onChange={props.handleProfileUploadCompression} />
    </FormGroup>
    }

        <FormGroup>
          <Label>What is your primary veterinary clinic?</Label>
          <Input type="text" name="vetHealthClinicName" onChange={props.onHandleChange} defaultValue={props.vetHealthClinic} placeholder="Veterinary Clinic"/>
          <br/>
          <Label onClick={() => alert('Leave this box empty if you do not have pet insurance')}>Who is your pet insurance provider? {'\u24d8'}</Label>
          <Input type="text" name="petInsurance" onChange={props.onHandleChange} defaultValue={props.petInsurance} placeholder="Pet Insurance Provider"/>
          <br/>
          <Label for="exampleEmail">Select the vaccinations your animal has received</Label>
          <Input type="select" name="animalVaccinations" id="animalVaccinations" defaultValue={props.animalVaccinations} onChange={props.onHandleMultipleChange} multiple>
            {
              props.animalType==="canine" ?
                  Object.keys(props.canineVacs).map((key) => {
                    return <option id={key} value={key}>{props.canineVacs[key].name}</option>
                    })
              : 
              Object.keys(props.felineVacs).map((key) => {
                return <option id={key} value={key}>{props.felineVacs[key].name}</option>
                })
          }
          </Input>
          <Label className="shrink" onClick={() => alert('DHLPP: Distemper, Hepatitis, Leptospira, Parvovirus, and Parainfluenza \n\nDHPP or DA2PP: Distemper, Hepatitis, Parvovirus, and Parainfluenza \n\nFVRCP: FVP, FHV-1, and FCV')} >Combination Vaccines {'\u24d8'}</Label>
        </FormGroup>

        <FormGroup>
          <Label style={{ fontWeight: 'bold' }}>Vaccines Selected: (click to remove)</Label>
          {
          (props.animalVaccinationsForDisplay === undefined)? null:
           props.animalVaccinationsForDisplay.map((vaccine, index) => (
            <FormGroup >
            <text className="vaccineText" onClick={() => props.removeVaccine(index)}> {vaccine} {props.editForm? "" :'Expires'}</text>
            {
              props.editForm? null:
              <Input type="date" id={index} defaultValue={`${props.animalVaccinations[index]}Date`} name={`${props.animalVaccinations[index]}Date`}  onChange={props.onHandleChange} />
            }
            </FormGroup>
          ))}
        </FormGroup>

    <br/>
   
        <div>
          {(props.animalVaccinations.length === 0) ?
            null :
            <div>
              <FormGroup>
                <br></br>
                <Label onClick={() => alert('Don\'t have proof of vaccination with you? No problem, these files can be uploaded later. Your tag will not display these vaccinations until the files are submitted and verified.')}
                >Upload proof of vaccination {'\u24d8'}</Label>
                <input type="file" id="centerFileUpload" accept=".pdf, .png, .jpg" name="fileVacs" onChange={props.handleProfileUploadCompression} />
              </FormGroup>
            </div>}
        </div>
    
    <br/>
    <h3>Additional Information</h3>
    {props.editForm ? null :
      <FormGroup>
      <Label onClick={() => alert('Under the Americans with Disabilities Act (ADA), “service animal means any dog that is individually trained to do work or perform tasks for the benefit of an individual with a disability, including a physical, sensory, psychiatric, intellectual, or other mental disability. Other species of animals, whether wild or domestic, trained or untrained, are not service animals for the purposes of this definition. The work or tasks performed by a service animal must be directly related to the individual\'s disability.”\n\nIn some circumstances, miniature horses may be recognized as a service animal.')}
          > Is this a Service Animal? {'\u24d8'}</Label>
      <Input type="select" name="isServiceAnimal" onChange={props.onHandleChange} defaultValue={false}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
      { (props.isServiceAnimal ===true || props.isServiceAnimal ==="true" ) ?
        <div>
          <br/>
      <Label for="isRequiredBecauseOfDisability">Is your animal required because of disability?</Label>
      <Input type="select" name="isRequiredBecauseOfDisability" onChange={props.onHandleChange} defaultValue={false}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
      {
       (props.isRequiredBecauseOfDisability ===true || props.isRequiredBecauseOfDisability==="true") ?  
       <div>
         <br/>
        <Label onClick={() => alert('Performing “work or tasks” means that the service animal is trained to take a specific action when needed to assist the person with a disability.\n\nPlease identify at least one action the service animal is trained to take which is helpful to the disability other than emotional support.\n\nSome specific examples of "work or tasks" include:\n- Alerting persons with hearing impairments to sounds.\n- Pulling wheelchairs or carrying and picking up things for persons with mobility impairments.\n- Assisting persons with mobility impairments with balance.')}
          > What work or task has your animal been trained to perform in support of your disability? {'\u24d8'}</Label>
        <Input type="select" name="serviceTaskSelect" onChange={props.onHandleChange} defaultValue={"task1"}>
        <option value={"Alert bystanders to an ongoing seizure"}>Alert bystanders to an ongoing seizure</option>
        <option value={"Alert to changes in blood glucose"}>Alert to changes in blood glucose</option>
        <option value={"Alert to noises"}>Alert to noises</option>
        <option value={"Alert to potential allergens"}>Alert to potential allergens</option>
        <option value={"Bring objects"}>Bring objects</option>
        <option value={"Create a physical barrier"}>Create a physical barrier</option>
        <option value={"Enter spaces before a human"}>Enter spaces before a human</option>
        <option value={"Lead visually impaired"}>Lead visually impaired</option>
        <option value={"Press buttons"}>Press buttons</option>
        <option value={"Pull a wheelchair"}>Pull a wheelchair</option>
        <option value={"Serve as a brace"}>Serve as a brace</option>
        <option value={"Turn on lights"}>Turn on lights</option>
        <option value={"other"}>Other</option>
       </Input>   
       { props.serviceTaskSelect=="other"?
       <Input type="text" name="serviceTask" id="serviceTask" placeholder="Please write service animal task" defaultValue={""} onChange={props.onHandleChange}/>
        :null
      }
       </div>:null
      }
       </div>
       : null
      }
    </FormGroup>
    }
    
    <FormGroup>
      <br/>
      <Label onClick={() => alert('A type of Assistance Animal that does work, performs tasks, provides assistance, and/or provides therapeutic emotional support for individuals with disabilities. A Support Animal is not a Service Animal.')}
          >Is this an Assistance Animal? {'\u24d8'}</Label>
      <Input type="select" name="emotionalSupportAnimal" onChange={props.onHandleChange} defaultValue={props.editForm ? props.emotionalSupportAnimal : props.emotionalSupportAnimal}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
    </FormGroup>
    {
      (props.emotionalSupportAnimal === false || props.emotionalSupportAnimal === "false") ?
        null :
        <div>
          <a  href="https://verfidpet.com/reasonable-accommodation" target="_blank">Upload supporting documentation for your reasonable accommodation request. {'\u24d8'}</a>
          <Input id="centerFileUpload" type="file" name="esaFile" accept=".jpg, .png, .pdf " onChange={props.handleProfileUploadCompression} />
          <br />
        </div>
    }

<FormGroup>
      <br/>
      <Label onClick={() => alert('For dogs, a municipality license is required by law in nearly all US municipalities. In some municipalities, this licensing requirement extends to cats.')}> Is this animal licensed in your municipality? {'\u24d8'}</Label>
      <Input type="select" name="licensed" onChange={props.onHandleChange} defaultValue={props.editForm ? false : props.licensed}>
        <option value={false}>No</option>
        <option value={true}>Yes</option>
      </Input>
    </FormGroup>
    {
      (props.licensed === false || props.licensed === "false") ?
        null :
        <div>
          <Label onClick={() => alert('Proof of licensure should clearly identify the municipality, the animal, and the expiration of the license.')}
              > Upload proof of municipality license. {'\u24d8'}</Label>
          <Input id="centerFileUpload" type="file" name="licenseFile" accept=".jpg, .png, .pdf " onChange={props.handleProfileUploadCompression} />
          <br />
        </div>
    }
   
   <br/>
    <FormGroup>
      <h3>Special Comments</h3>
      <Input type="textarea" name="animalComments" rows="4" placeholder="Enter special handling information, additional contacts, allergies, medications, or any other important information." defaultValue={props.editForm ? props.comment : props.animalComments} onChange={props.onHandleChange} />
    </FormGroup>
    <br/>
    <FormGroup className="profileUploadBlock">
    <h3 onClick={() => alert('Don\'t have your favorite picture with you? No problem, this picture can easily be changed in the future.')}
          >Animal Picture {'\u24d8'}</h3>
      {
        props.dogImageBlob === null ? null : <img src={props.dogImageBlob} className="imagePreview" alt="Preview of Image" />
      }
      <input type="file" name="dogImage" id="centerFileUpload" accept=".jpg, .png" onChange={props.handleProfileUploadCompression} />
    </FormGroup>
    <br/>
    {
      props.editForm ? null :
    <h3>Liability</h3>
    }
    {
      props.editForm ? null :
        <FormGroup>
          <input type="checkbox" name="generalLiability" id="generalLiabilty" defaultChecked={props.generalLiability} onChange={props.onHandleChange} zoom="2"></input> 
          <Label>By checking the box, you agree to the terms in the</Label>
          <Label className="underline" onClick={() => alert('Animal Behavior and Liability Statement \n \nBy checking this box you confirm that your animal has never caused serious bodily or psychological harm to a human or other animal, does not act aggressively or maliciously to humans or other animals, is not considered a nuisance to humans or other animals, and is considered well-behaved in public settings. \n\nTo the best of your knowledge, your animal is free from any contagious diseases or conditions that would make it a danger to another animal or human. You understand that VERFID LLC, its members, business associates, and participating Business Account holders are not responsible for the behavior or actions of your animal. Without exception, you accept full responsibility for any damage(s) to persons, animals, or properties as a result of actions caused by your animal. ')}
          >Behavioral and Liability Agreement</Label>
        </FormGroup>
    }
    </Form>
);


class AnimalRegistration extends Component {
  constructor(props) {
    super(props)

    this.state = {
      amountSet: 3290,
      animalBirthDate: null,
      ownedDate: null,
      formStatus: '',
      authStatus: false,
      invalidPassword: false,
      invalidPassword2: false,
      email: '',
      password: '',
      address: '',
      firstName: '',
      lastName: '',
      animalName: '',
      animalColor: 'black',
      month: 'Jan',
      gender: 'Male',
      fixed: true,
      animalType: 'canine',
      accountCreationType: 'newAccount',
      breed: 'Affenpinscher',
      breed2: 'Not Applicable',
      file: null,
      filesSpayNueter: null,
      country: 'United States',
      profilePicture: null,
      profilePictureBlob: null,
      animalVaccinations: [],
      vetHealthClinicName: "",
      animalVaccinationsForDisplay: [],
      dogImage: null,
      dogImageBlob: null,
      veterinaryHealthCertificate: null,
      fecalExamCertificate: null,
      FecalExamExpirationDate: 0,
      step: 1, //DH change this back to 1
      userPaid: false,
      successfulAccountCreation: false,
      agreeToPrivacy: false,
      generalLiability: false,
      emotionalSupportAnimal: false,
      vetHealthCert: false,
      uploading: false,
      phoneNumberPrimary: null,
      phoneNumberValidLongChars: false,
      phoneNumberTooShort: false,
      phoneNumberTooShortIndicator: false,
      promoCode: '',
      isLoadingSomething: false,
      datesInOrder: true,
      datesInFuture: false,
      newUser: true,
      referral: '',
      fecalExam: false,
      hasSubmitted: false,
      shippingType: 'standard',
      enableStep4: false,
      enableStep3: false,
      invalidZipLength: false,
      isServiceAnimal: false,
      webAppVersion: "3.21",
      isRequiredBecauseOfDisability: false,
      serviceTaskSelect: "task1",
      serviceTask: "placeHolder",
      pageLoading: false,
      VetHealthIssueDate: 0,
      VetHealthExpirationDate: 0,
      licensed: false,
      licenseFile: null,
      petInsurance: '',
      crop: {
        aspect: 1 / 1,
        width: 150,
        height: 150,
        maxWidth: 300,
        maxHeight: 300,
        minWidth: 100,
        minHeight: 100
      }
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onHandleChange = this.onHandleChange.bind(this)
    this.checkPromoCode = this.checkPromoCode.bind(this)
    this.handleProfileUploadCompression = this.handleProfileUploadCompression.bind(this)
    this.handleMultipleChange = this.handleMultipleChange.bind(this)
    this.uploadDogImageFile = this.uploadDogImageFile.bind(this)
    this.uploadVaccinations = this.uploadVaccinations.bind(this)
    this.uploadSpayNeuter = this.uploadSpayNeuter.bind(this)
    this.uploadVetHealthCertificate = this.uploadVetHealthCertificate.bind(this)
    this.uploadFecalExamCertificate = this.uploadFecalExamCertificate.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
    this.uploadESANote = this.uploadESANote.bind(this);
    this.uploadLicense = this.uploadLicense.bind(this);
    this.checkDates = this.checkDates.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.checkStep1 = this.checkStep1.bind(this);
    this.checkStep3 = this.checkStep3.bind(this);
    this.checkStep4 = this.checkStep4.bind(this);
    this.lastStep = this.lastStep.bind(this);
    this.handleOnCropChange = this.handleOnCropChange.bind(this);
    this.checkLogin = this.checkLogin.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  
  }

  checkLogin(){
  var user = firebase.auth().currentUser;
      if (user) {
        var userRef = firebase.firestore().collection('users').doc(`${user.uid}`);
        var webRef = firebase.firestore().collection('webVersion').doc(`version`);

        webRef.get().then((doc)=>{
            if(doc.data().rev!==this.state.webAppVersion){
              alert('We have detected that you are using an old version of the website. \nPlease refresh your browser');
            }
        })

          //store vaccinations definitions
          firebase.firestore().collection('vaccinations').doc('canine').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({canineVacs:doc.data()})
            }
          })

          firebase.firestore().collection('vaccinations').doc('feline').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({felineVacs:doc.data()})
            }
          })

          //store cert definitions
          firebase.firestore().collection('certificates').doc('canine').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({canineCerts:doc.data()})
            }
          })

          firebase.firestore().collection('certificates').doc('feline').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({felineCerts:doc.data()})
            }
          })

          //store form definitions
          firebase.firestore().collection('forms').doc('canine').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({canineForms:doc.data()})
            }
          })

          firebase.firestore().collection('forms').doc('feline').get()
          .then((doc) => {
            if (doc.exists) {
              this.setState({felineForms:doc.data()})
            }
          })
            

      userRef.get().then((doc) => {
          // User has a real profile
            if (doc.exists) {

                this.setState({
                  step:3,
                  pageLoading: false,
                  newUser: false,
                  userID: doc.data().userId,
                });
            }
            else {
              var user = firebase.auth().currentUser;
              var businessRef = firebase.firestore().collection('businesses').doc(`${user.uid}`);
              //set user ID in case they started creating account but didn't finish
              this.setState({
                userID: user.uid
              });
              businessRef.get().then((doc) => {
                //detected it was a business login if true
                if (doc.exists) {
                  this.setState({
                    newUser: true,
                    pageLoading: false})
                } 
                //detected it was an unfinished user account
                else {
                  this.setState({
                    step:2,
                    newUser: true,
                    pageLoading: false})
                  }
              })
            }//else
          })    
      } else {
        this.setState({
          pageLoading: false})
      // No user is signed in.
      }
}

  

  handleFileChange(e) {
    var fileArray = [];
    for (var i = 0; i < e.target.files.length; i++) {
      fileArray.push(e.target.files[i]);
    };
    this.setState({
      files: fileArray,
    })
  }

  handleFileChangeSN(e) {
    var fileArray = [];
    for (var i = 0; i < e.target.files.length; i++) {
      fileArray.push(e.target.files[i]);
    };
    this.setState({
      filesSpayNueter: fileArray,
    })
  }

  handleOnCropChange = (crop) => {
    this.setState({ crop: crop })
  }

  successfulPayment = () => {
    firebase.database().ref('/payments/' + this.state.userId).on('value', snapshot => {
      if (snapshot) {
        this.setState({
          userPaid: true,
        })
      };
    });
  }

  removeVaccine = (index) => {
    var values = this.state.animalVaccinations;
    var valuesToDisplay = this.state.animalVaccinationsForDisplay;
    values.splice(index, 1);

    valuesToDisplay.splice(index, 1);

    this.setState({
      animalVaccinations: values,
      animalVaccinationsForDisplay: valuesToDisplay,
    });
  }

  uploadESANote(animalId) {
    var storageRef = firebase.storage().ref();
    var file = this.state.esaFile;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    var fileType = 'pdf';

    fileID = `${animalId}_${uploadDate}`;

    if ((file === null) || (file === undefined)) {
      return;
    } else {
      if(file.type.includes('image')){
        if(file.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`emotionalSupportNotes/${fileID}`).put(file); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
       
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificates",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "support animal",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  }

  uploadLicense(animalId) {
    var storageRef = firebase.storage().ref();
    var file = this.state.licenseFile;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    var fileType = 'pdf';

    fileID = `${animalId}_${uploadDate}`;

    if ((file === null) || (file === undefined)) {
      return;
    } else {
      if(file.type.includes('image')){
        if(file.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`license/${fileID}`).put(file); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
       
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificates",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "municipality license",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  }



  handleProfileUpload(e) {
    // console.log(e.target.files[0]);
    // console.log(e.target.name);
    var name = e.target.name;
    this.setState({
      [name]: e.target.files[0],
    });
  }

  handleProfileUploadCompression(e) {
      var name = e.target.name;
      var name2 = e.target.name + "Blob";
      var imageFile = e.target.files[0];
  
      var options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 1920,
        useWebWorker: true
      }

      if(imageFile===undefined || imageFile===null || imageFile===[]){
        //do nothing if invalid file
      }else{
  
      if(imageFile.type.includes('image')){
        imageCompression(imageFile, options)
        .then((compressedFile) => {
          this.setState({ [name]: compressedFile });
          this.setState({ [name2]: URL.createObjectURL(compressedFile) }, null);
          return compressedFile;
        })
        .then(function (compressedFile) {
  
        })
        .catch(function (error) {
          alert('Your image was unable to be compressed');
        });
      }
      else{
        this.setState({ [name]: imageFile,
          [name2]: URL.createObjectURL(imageFile)
        });
      }
    }
  
  }

  // animal GUID creator functions
  uploadFile(e) {
    var storageRef = firebase.storage().ref();
    var profilePicture = this.state.profilePicture;
    var db = firebase.firestore();
    if ((profilePicture === null) || (profilePicture===undefined)) {
      return;
    } else {
      const uploadTask = storageRef.child(`profileImage/${this.state.userID}`).put(profilePicture); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          db.collection('users').doc(`${this.state.userID}`).update({
            imageUrl: downloadURL,
          })
        });
      });
    }
  }

  handleMultipleChange(e) {
    var name;
    var item;
    var itemToDisplay;
    var values = this.state.animalVaccinations;
    var valuesToDisplay = this.state.animalVaccinationsForDisplay;

    //Adding loop through all options to hopefully catch the iphone case
    for (var i = 0; i < e.target.options.length; i++) {
      if (e.target.options[i].selected) {
        name = e.target.options[i].name;
        item = e.target.options[i].value;
        itemToDisplay = e.target.options[i].innerHTML;
        if (values.indexOf(item) < 0) {
          values.push(item);
        };
        if (valuesToDisplay.indexOf(itemToDisplay) < 0) {
          valuesToDisplay.push(itemToDisplay);
        }
      }
    }//loop through all select options
    this.setState({
      [name]: values,
      animalVaccinationsForDisplay: valuesToDisplay,
    });
  }

  uploadDogImageFile(animalID) {
    var storageRef = firebase.storage().ref();
    var db = firebase.firestore();

    var dogPicture = this.state.dogImage;
    if (dogPicture === null) {
      return;
    }
    const uploadTask = storageRef.child(`dogImage/${animalID}`).put(dogPicture); //create a child directory called images, and place the file inside this directory
    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
    }, (error) => {
      // Handle unsuccessful uploads
    }, (snapshot) => {
      // Do something once upload is complete
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        db.collection('animals').doc(`${animalID}`).update({
          imageUrl: downloadURL,
        })
      });

    });
  }
  
  uploadFecalExamCertificate(animalID) {

    var storageRef = firebase.storage().ref();
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalID}_${uploadDate}`;
    
    var fileType = 'pdf';
    var fecalExam = this.state.fecalExamCertificate;
    if ((fecalExam === null) || (fecalExam===[]) || (fecalExam===undefined)) {
      return;
    } else {
      if(fecalExam.type.includes('image')){
        if(fecalExam.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`fecalExam/${fileID}`).put(fecalExam); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalID).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificate",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "fecalExam",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
   
  }

  /*
  uploadFecalExamCertificate(animalID) {
    var storageRef = firebase.storage().ref();
    var db = firebase.firestore();
    var fecalExam = this.state.fecalExamCertificate;
    if ((fecalExam === null) || (fecalExam===[])) {
      return;
    }
    const uploadTask = storageRef.child(`fecalExam/${animalID}`).put(fecalExam); //create a child directory called images, and place the file inside this directory
    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
    }, (error) => {
      // Handle unsuccessful uploads
    }, (snapshot) => {
      // Do something once upload is complete
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
      });

    });
  } */

  uploadVetHealthCertificate(animalId) {
    var storageRef = firebase.storage().ref();
    var vetNote = this.state.veterinaryHealthCertificate;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    
    var fileType = 'pdf';
    if ((vetNote === null) || (vetNote === undefined)) {
      return;
    } else {
      if(vetNote.type.includes('image')){
        if(vetNote.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`veterinaryHealthCertificate/${fileID}`).put(vetNote); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificate",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "vet health certificate",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  }

/*  uploadVeterinaryHealthCertificate(animalID) {
    var storageRef = firebase.storage().ref();
    var db = firebase.firestore();
    var dogPicture = this.state.veterinaryHealthCertificate;
    if (dogPicture === null) {
      return;
    }
    const uploadTask = storageRef.child(`veterinaryHealthCertificate/${animalID}`).put(dogPicture); //create a child directory called images, and place the file inside this directory
    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
    }, (error) => {
      // Handle unsuccessful uploads
    }, (snapshot) => {
      // Do something once upload is complete
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
      });

    });
  }
*/

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  guid() {
    return this.s4() + this.s4() + this.s4() + this.s4();
  }

  checkDates(ownershipDate2) {
    var animalBirthDateString = new Date(this.state.animalBirthDate);
    var ownedDateString = new Date(ownershipDate2);
    var dateNow = Date.now();
   // console.log("now:", dateNow);
  //  console.log("birthdate", animalBirthDateString.getTime());
    var comparison = ownedDateString.getTime() >= animalBirthDateString.getTime();
    var comparison2 = animalBirthDateString.getTime() >= dateNow;
    this.setState({
      datesInOrder: comparison,
      datesInFuture: comparison2
    });
    //return 1 if they are good
    //return 0 if theya re not
    return (comparison && !comparison2);
  }



  handleSubmit() {
    var animalUID = this.guid();
    var db = firebase.firestore();
    var accountCreationDate = Date.now();
    var FecalExamExpirationDateString = new Date(this.state.FecalExamExpirationDate);
    var FecalExamExpirationDateToPost = FecalExamExpirationDateString.getTime() + 86400000;//adds one day to the string;
    var FecalExamHumanReadableDate = (new Date(FecalExamExpirationDateToPost).toLocaleString());

    var VetHealthIssueString =  new Date(this.state.VetHealthIssueDate);
    var VetHealthExpirationString =  new Date(this.state.VetHealthExpirationDate);
    var VetHealthIssueDateToPost =  VetHealthIssueString.getTime() + 86400000;
    var VetHealthExpirationDateToPost =  VetHealthExpirationString.getTime() + 86400000;
    var VetHealthIssueHumanReadable =  (new Date(VetHealthIssueDateToPost).toLocaleString());
    var VetHealthExpirationHumanReadable =  (new Date(VetHealthExpirationDateToPost).toLocaleString());


    //add 1 to animal birthdate to correct for time zone issues
    var animalBirthDateString = new Date(this.state.animalBirthDate);
    var animalBirthDate = animalBirthDateString.getTime() + 86400000;//adds one day to the string
    //add 1 to animal got you date to correct for time zone issues
    var ownedDateString = new Date(this.state.ownershipDate);
    var ownedDate = ownedDateString.getTime() + 86400000;//adds one day to the string
    var weight = parseInt(this.state.weight, 10);
    var userRef = db.collection('users').doc(`${this.state.userID}`);
    var fixed = (this.state.fixed === "true" || this.state.fixed === true) ? true : false;
    var emotionalSupportAnimal = (this.state.emotionalSupportAnimal === true || this.state.emotionalSupportAnimal === "true") ? true : false;
    var emotionalSupportFileExists = (this.state.esaFile !== null && this.state.esaFile !== [] && this.state.esaFile !== undefined) ? true : false;
    var vetHealthCertSelected = (this.state.vetHealthCert === true || this.state.vetHealthCert === "true") ? true : false;
    var vetHealthCertFileExists = (this.state.veterinaryHealthCertificate !== null && this.state.veterinaryHealthCertificate !== [] && this.state.veterinaryHealthCertificate !== undefined) ? true : false;
    var userID = this.state.userID;
    var licenseCert = `${this.state.animalType}Cert500`;
    var serviceCert = `${this.state.animalType}Cert10`;
    var animalCert = `${this.state.animalType}Cert9`;
    var fecalCert = `${this.state.animalType}Cert3`;
    var vetCert = `${this.state.animalType}Cert0`;
    var liabilityCert = `${this.state.animalType}Form0`;
    var liability = this.state.generalLiability === "on" ? true : false;
    var breed2Parsed = this.state.breed2 === "Not Applicable" ? '' : this.state.breed2;
    this.setState({
      uploading: true,
    });
    {
      this.state.newUser ?
        userRef.set({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          address: {
            city: this.state.city,
            state: this.state.state,
            line1: this.state.line1,
            line2: this.state.line2 || "",
            country: this.state.country || 'United States',
            zip: this.state.zip,
          },
          animals: [animalUID],
          phoneNumberPrimary: this.state.phoneNumberPrimary,
          phoneNumberSecondary: this.state.phoneNumberSecondary || "",
          birthDate: 0,
          imageUrl: '',
          userId: userID,
          referredBy: this.state.referral,
          promoCode: this.state.promoCode,
        }) : userRef.update({ animals: firebase.firestore.FieldValue.arrayUnion(animalUID) })
    }
    
      if(this.state.accountCreationType === 'createUserProfile'){
      this.uploadFile(userID);
      setTimeout(() => {
        this.setState({
          successfulAccountCreation: true,
        })
      }, 5000)
      }else{
      db.collection('animals').doc(`${animalUID}`).set({
      color: this.state.animalColor,
      name: this.state.animalName,
      breed: this.state.breed,
      breed2: breed2Parsed,
      userId: this.state.userID,
      species: this.state.animalType,
      verified: false,
      weight: weight,
      gender: this.state.gender,
      fixed: fixed,
      isServiceAnimal: this.state.isServiceAnimal,
      isRequiredBecauseOfDisability: this.state.isRequiredBecauseOfDisability,
      serviceTask: this.state.serviceTaskSelect,
      birthDate: animalBirthDate,
      ownedSince: ownedDate,
      animalId: animalUID,
      submission: true,
      dateCreated: accountCreationDate,
      comment: this.state.animalComments || '',
      imageUrl: '',
      webAppVersion: this.state.webAppVersion,
      liabilityChecked: liability,
      referredBy: this.state.referral,
      promoCode: this.state.promoCode,
      shippingType: this.state.shippingType,
      vetHealthClinic: this.state.vetHealthClinicName,
      petInsurance: this.state.petInsurance,
    })
    .then(() => this.state.animalVaccinations.map(vaccination => {
      if (this.state[`${vaccination}Date`] !== undefined){   
        var expDateString = new Date(this.state[`${vaccination}Date`]);
        var expDate = expDateString.getTime() + 86400000;//adds one day to the string
        var expDateReadable = new Date(expDate).toLocaleString();
      }
      else{
        var expDate = 0;//adds one day to the string
        var expDateReadable = "None Provided";
      }
        db.collection('animals').doc(`${animalUID}`).collection('vaccinations').doc(`${vaccination}`).set({
          verified: false,
          fileUrl: ``,
          expiration: expDate,
          expirationHumanReadable: expDateReadable,
        })
    }))
    .then(() => emotionalSupportAnimal ? db.collection('animals').doc(`${animalUID}`).collection('certificates').doc(`${animalCert}`).set({
        verified: false,
        expiration: 0,
        fileUrl: `gs://verfid-db.appspot.com/files/${animalUID}/${animalCert}.pdf`,
    }) : null)
    .then(() => (this.state.fecalExam===true || this.state.fecalExam==="true") ? db.collection('animals').doc(`${animalUID}`).collection('certificates').doc(`${fecalCert}`).set({
      verified: false,
      expiration: Number.isNaN(FecalExamExpirationDateToPost)?0:FecalExamExpirationDateToPost,
      expirationHumanReadable: FecalExamHumanReadableDate,
      fileUrl: `gs://verfid-db.appspot.com/files/${animalUID}/${animalCert}.pdf`,
  }) : null)
    .then(() => vetHealthCertSelected ? db.collection('animals').doc(`${animalUID}`).collection('certificates').doc(`${vetCert}`).set({
        verified: false,
        issue: Number.isNaN(VetHealthIssueDateToPost)? 0:VetHealthIssueDateToPost,
        issueHumanReadable: VetHealthIssueHumanReadable,
        expiration:Number.isNaN(VetHealthIssueDateToPost)?0:VetHealthExpirationDateToPost,
        expirationHumanReadable:VetHealthExpirationHumanReadable,
        fileUrl: `gs://verfid-db.appspot.com/files/${animalUID}/${vetCert}.pdf`,
      }) : null)
      .then(() => (this.state.isRequiredBecauseOfDisability || this.state.isRequiredBecauseOfDisability==="true") ? db.collection('animals').doc(`${animalUID}`).collection('certificates').doc(`${serviceCert}`).set({
        verified: false,
        fileUrl: `gs://verfid-db.appspot.com/files/${animalUID}/${serviceCert}.pdf`,
        serviceTask: (this.state.serviceTaskSelect==="other") ? this.state.serviceTask : this.state.serviceTaskSelect,
      }) : null)
      .then(() => liability ? db.collection('animals').doc(`${animalUID}`).collection('forms').doc(`${liabilityCert}`).set({
        verified: true,
      }) : null)
      .then(() => (this.state.licensed===true || this.state.licensed==="true") ? db.collection('animals').doc(`${animalUID}`).collection('certs').doc(`${licenseCert}`).set({
        verified: true,
        expiration: 0,
      }) : null)
      .then(() => this.setState({
        uploading: true,
      }))
      .then(() => {
        this.uploadFile(userID);
      })
      .then(() => this.state.fecalExam? this.uploadFecalExamCertificate(animalUID): null)
      .then(() => this.uploadDogImageFile(animalUID))
      .then(() => emotionalSupportFileExists ? this.uploadESANote(animalUID) : null) 
      .then(() => (this.state.licenseFile === null || this.state.licenseFile === [] || this.state.licenseFile === undefined) ? null: this.uploadLicense(animalUID))
      .then(() => (this.state.fileSN === null || this.state.fileSN === []) ? null : this.uploadSpayNeuter(animalUID))
      .then(() => (this.state.fileVacs === null || this.state.fileVacs === [] || this.state.fileVacs === undefined) ? null : this.uploadVaccinations(animalUID))
      .then(() => vetHealthCertFileExists ? this.uploadVetHealthCertificate(animalUID) : null)
      .then(() => setTimeout(() => {
        this.setState({
          successfulAccountCreation: true,
        })
      }, 15000))
      .catch(error => console.error('this error: ', error));
      }
  }

  checkPromoCode() {

    var db = firebase.firestore();
    var location = db.collection('promoCodes').doc(this.state.promoCode);
    var paid = false;
    var newPrice = this.state.amountSet;
    var validCode = false;
    var expiredUses = 999;
    var uses;

    location.get().then(function (doc) {

      if (doc.exists) {
        if (doc.data().price === undefined || doc.data().text === undefined) {
          //this case indicates an invalid database entry for a promo code
          alert("VERFID has encountered some issues, please notify us if your promo code is not working")

        } else {
          //check on max use cases
          if (doc.data().maxUses === undefined || doc.data().maxUses === undefined) {
            expiredUses = 999;
          }
          else{
            expiredUses = doc.data().maxUses;
          }

          if(doc.data().uses === undefined || doc.data().uses === undefined){
            uses = 1;
           }
           else{
             uses = doc.data().uses + 1;
           }

          if(uses<=expiredUses){
             validCode = true;
             alert(doc.data().text)
             if (doc.data().price === 0) {
               paid = true;
             }
             else {
               newPrice = doc.data().price;
             }
            }
            else{
              alert("This promo code has already been used.")
            }
          }//it has a valid structure
      }//promocode exists
      else {
        alert("We are unable to recognize that promo code. If you believe this is a mistake, please contact the VERFID team and we will resolve it immediately.")
      }
    }).then(() => this.setState({
      userPaid: paid,
      amountSet: newPrice,
    }))
    .then(()=> {

     if(validCode){
       //only update on a valid code
        location.update({
        uses:uses
      })}})
    
  }

  uploadVaccinations(animalId) {

    var storageRef = firebase.storage().ref();
    var file = this.state.fileVacs;
    var db = firebase.firestore();
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    var fileType = 'pdf';

    
      fileID = `${animalId}_${uploadDate}`;

    if ((file === null) || (file === undefined)) {
      return;
    } else {
      if(file.type.includes('image')){
        if(file.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`vaccinations/${fileID}`).put(file); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "vaccinations",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "vaccinations",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }

    /*var storageRef = firebase.storage().ref();
    var uploadFiles = this.state.files;

    var i = 0;
    uploadFiles.forEach((file, i) => {
      const uploadTask = storageRef.child(`vaccinations/${animalId}-${i}`).put(file);
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        });
      });
      i++;
    }) */
  }

  uploadSpayNeuter(animalId) {
    var storageRef = firebase.storage().ref();
    var uploadFile = this.state.fileSN;
    var db = firebase.firestore();
    ///var fileID = Math.floor((1 + Math.random()) * 0x10000).toString(4).substring(1);
    var uploadDate = Date.now();
    var fileID = `${animalId}_${uploadDate}`;
    
    var fileType = 'pdf';
    if ((uploadFile === null) || (uploadFile === undefined)) {
      return;
    } else {
      if(uploadFile.type.includes('image')){
        if(uploadFile.type.includes('png')){
          fileType = 'png';
        }
        else{
          fileType = 'jpeg';
        }
      }
       else{
        fileType = 'pdf';
      }

      const uploadTask = storageRef.child(`SpayNeuter/${fileID}`).put(uploadFile); //create a child directory called images, and place the file inside this directory
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Do something once upload is complete
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          db.collection('animals').doc(animalId).collection('documents').doc(fileID).set({
            comment: "",
            documentType: "certificate",
            filePath: downloadURL,
            fileType: fileType,
            id: fileID,
            lastServiceDate: 0,
            serviceComment: '',
            serviced: false,
            servicedBy: "VERFID",
            status: "initial upload",
            type: "spay and neuter",
            uploadDate: uploadDate
          }, {
              merge: true
            });
        });
      });
    }
  }

  onHandleChange(e) {
    var value = e.target.value;
    var name = e.target.name;
    
    this.setState({
      [name]: value,
      
    });
    
    if (name === 'shippingType' && value === 'expedited') {
      this.setState({
        amountSet: this.state.amountSet + 500,
      })

    }

    if (name === 'shippingType' && value === 'standard') {
      this.setState({
        amountSet: this.state.amountSet - 500,
      })

    }

    if (name === 'agreeToPrivacy') {
      this.setState({
        agreeToPrivacy: !this.state.agreeToPrivacy,
      })
    }

  }

   checkStep1(){
      if (this.state.password.length < 6 || this.state.password==="password" || this.state.password==="Password") {
        this.setState({
          invalidPassword: true,
        })
      }
      else{
        this.setState({
          invalidPassword: false,
        })
      }

      if ((this.state.password2 !== this.state.password) && (this.state.accountCreationType === 'newAccount' || this.state.accountCreationType === 'createUserProfile')) {
        this.setState({
          invalidPassword2: true,
        })
      } 
      else {
        this.setState({
          invalidPassword2: false,
        }
        );
      }
    
    }

 

  checkStep3() {
    var invalidStep = false;
    //check for name
    if (this.state.firstName === null || this.state.lastName === null) {
      invalidStep = true;
    }
    if (this.state.firstName === "" || this.state.lastName === "") {
      invalidStep = true;
    }
    //check address
    if (this.state.zip.length < 6) {
        this.setState({
          invalidZipLength: false,
        })
      }
      else {
        this.setState({
          invalidZipLength: true,
        })
      }

        /*
        if (this.state.phoneNumberPrimary.validity.patternMismatch || this.state.phoneNumberPrimary.validity.tooLong) {
          this.setState({
            phoneNumberValidLongChars: true,
          })
        }
        else {
          this.setState({
            phoneNumberValidLongChars: false,
          })
        }
          */
        if (this.state.phoneNumberPrimary.length<10) {
          this.setState({
            phoneNumberTooShort: true,
            phoneNumberTooShortIndicator: true,
          })
        }
        else {
          this.setState({
            phoneNumberTooShort: false,
            phoneNumberTooShortIndicator: false,
          })
        }

    if (this.state.line1 === null || this.state.zip === null || this.state.zip.length>6 || this.state.country === null || this.state.city === null || this.state.state === null) {
      invalidStep = true;
    }
    if (this.state.line1 === "" || this.state.zip === "" || this.state.country === "" || this.state.city === "" || this.state.state === "") {
      invalidStep = true;
    }
    //check phone
    if (this.state.phoneNumberPrimary === null || this.state.phoneNumberPrimary.length<10 || this.state.phoneNumberPrimary === "" ) {
      invalidStep = true;
    }


    if (this.state.agreeToPrivacy === false || this.state.agreeToPrivacy ==="false"){
      invalidStep = true;
    }
    this.setState({
      enableStep3: !invalidStep,
    })
  }

  checkStep4() {
    var invalidStep = false;

    //first check for a valid name
    if (this.state.animalName === null || this.state.animalName === "") {
      invalidStep = true;
      
    }
    if(this.checkDates(this.state.ownershipDate)==false){
      invalidStep = true;
    };
    //now check for a weight
    if (this.state.weight === null || this.state.weight === "") {
      invalidStep = true;
    }
    //now check for dates
    if (this.state.animalBirthDate === null || this.state.ownershipDate === null) {
      invalidStep = true;
    }
    if (this.state.animalBirthDate === "" || this.state.ownershipDate === "") {
      invalidStep = true;
    }

    this.setState({
      enableStep4: !invalidStep,
    })

  }


  nextStep() {
    if (this.state.step === 1) {
      var db = firebase.firestore();
      var userExists;
      var incrementN = this.state.step + 1;
      var increment = 0;
      const userInfo = firebase.auth().currentUser;

    this.checkStep1();
  
    this.setState({ isLoadingSomething: true }, () => {
        if(this.state.invalidPassword || this.state.invalidPassword2){
          //do nothing
          this.setState({ isLoadingSomething: false })
        }else{
      firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
        //   })//set state and login
        .then(() => {
          var location = db.collection('users').doc(`${userInfo.uid}`);
          location.get().then(function (doc) {

            if (doc.exists) {
              userExists = true;
            } else {
              userExists = false;
            }
          });
        })
        .then(() => {
          setTimeout(() => {
            if (userInfo.uid && userExists) {
              this.setState({
                userID: userInfo.uid,
                step: incrementN+1,
                newUser: false,
                //  isSignedIn: true,
                //  userID: userInfo,
              })
            }
            else {

              this.setState({
                userID: userInfo.uid,
                step: incrementN,
                newUser: true,
                //  isSignedIn: true,
                //              userID: userInfo,
              })
            }
          }, 2000) //need delay for db read to happen
        })
        .catch((error) => {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
          firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
            .then(snapshot => {
              firebase.auth().currentUser.sendEmailVerification().catch(err => console.log(err))
              .then(()=> firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password).catch(err => console.log(err))
            )
              .then(()=>{
              var increment = this.state.step + 1;
              this.setState({
                step: 2,
                userID: snapshot.user.uid,
              })
            })
          })   
            .catch(err => {
              this.setState({
                authStatus: true,
                isLoadingSomething: false
              })
            })//catches creating new profile
        }); //catches invalid login
      }//else checked for valid password
      }//end call back function
     )//end set state
    }//if step 1 statement
    else{
        if(this.state.step === 2){
        this.checkStep3();
         }
         else{
          this.checkStep4();
         }

        this.setState({isLoadingSomething:true},()=>
      {
        if((this.state.enableStep3 && this.state.step===2) || (this.state.enableStep4 && this.state.step===3)){

      if(this.state.step === 2 && this.state.accountCreationType==='createUserProfile'){
        increment = 4; //submitted account for creation
        this.handleSubmit();
      }else{
        var increment = this.state.step + 1;
      }

      if (this.state.phoneNumberTooShort) {
        this.setState({
          phoneNumberTooShortIndicator: true,
        })
      }
      else {
        this.setState({
          step: increment,
          isLoadingSomething: false
        })
      }
      }
      else{
        alert('One or more inputs are missing or incorrect')
        this.setState({isLoadingSomething:false})
      }
    }//call back after loading 
        )//this.state call
    } //step is 2
  }
  
  lastStep() {
    if (this.state.step > 1) {
      var decrement = this.state.step - 1
    } else {
      var decrement = 1;
    }

    this.setState({
      step: decrement
    })
  }

  componentDidMount() {
    let myApp = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        if(myApp.state.step==1){
        myApp.checkLogin();
        }
        // User is signed in.
      } else {
        // No user is signed in.
      }
    });

    setTimeout(() => {
      this.checkLogin();
    }, 2000);

  }

  showStep(props) {
    const user = {
      email: this.state.email,
      password: this.state.password,
      address: this.state.address,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      profileImage: this.state.profileImage,
    }
    const animal = {
      animalName: this.state.animalName,
      animalColor: this.state.animalColor,
      fixed: this.state.fixed,
    }
    const onHandleChangeProps = this.onHandleChange;
    const onHandleFileChange = this.handleFileChange;
    const onHandleFileChangeSN = this.handleFileChangeSN;
    const handleOnCropChangeProps = this.handleOnCropChange;
    const removeVaccine = this.removeVaccine;
    const handleProfileUploadCompressionProps = this.handleProfileUploadCompression;
    const handleMultipleChange = this.handleMultipleChange;
    const checkDatesProps = this.checkDates;
    const userPaid = this.successfulPayment;
    const checkPromoCodeProps = this.checkPromoCode;

    switch (this.state.step) {
      case 1:
        return <Step1 {...props} user={user} handleOnCropChange={handleOnCropChangeProps} onHandleChange={onHandleChangeProps} />
      case 2:
        return <Step2 {...props} user={user} animal={animal} onHandleMultipleChange={handleMultipleChange} onHandleChange={onHandleChangeProps} handleProfileUploadCompression={handleProfileUploadCompressionProps} handleFileChange={onHandleFileChange} />
      case 3:
        return <Step3 {...props} user={user} onHandleChange={onHandleChangeProps} removeVaccine={removeVaccine} handleProfileUploadCompression={handleProfileUploadCompressionProps} onHandleMultipleChange={handleMultipleChange} handleFileChange={onHandleFileChange} handleFileChangeSN={onHandleFileChangeSN} />
      case 4:
        return <Step4 {...props} user={user} checkPromoCode={checkPromoCodeProps} userPaid={userPaid} userPaidLogic={this.state.userPaid} onHandleChange={onHandleChangeProps} onCheckDates={checkDatesProps} />
      default:
        return <Step1 {...props} user={user} onHandleChange={onHandleChangeProps} />
    };
  }
  render() {
    var style = {
      width: (this.state.step / 4 * 100) + '%'
    }
    return (
      <div className="padding">
        {this.state.successfulAccountCreation ?
          <div id="stepDiv">
            {
              this.state.accountCreationType === 'createUserProfile' ?
              <div>
            <h2>Thank you for creating your account.</h2>
            <h4>Go to the profile section to add your animals.</h4>
            </div>
            :
            <div>
            <h2>Congratulations, your smart tag is on its way!</h2>
            <h4>Go to the profile tab to continue editing your account.</h4>
            </div>
            }
          </div> :
          <div>
            <progress className="progress" style={style}></progress>
            <br />
            <div id="stepDiv">
              {
                this.state.uploading ?
                  <div>
                    <h2>Uploading your information and creating your account! Please wait.</h2>
                    <h4>This upload can take up to a few minutes.</h4>
                    <div className="CenterImage">
                      <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true} />
                    </div>
                  </div> :
                  this.showStep(this.state)
              }
            </div>
            <div id="nextStepButtonDiv">
              <Button disabled={this.state.step===1 || (this.state.step === 3 && !this.state.newUser)} onClick={this.lastStep}>{this.state.step === 1 ? <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div> : "Last"}</Button>
              {
                <Button disabled={this.state.uploading || (this.state.step === 4 && !this.state.userPaid)} onClick={this.state.step === 4 ? this.handleSubmit : this.nextStep}>{(this.state.step === 4 || (this.state.step === 2 && this.state.accountCreationType==='createUserProfile')) ? 'Submit' : 'Next'}</Button>
              }
            </div>
          </div>}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AnimalRegistration);



// WEBPACK FOOTER //
// ./src/components/animalAccountRegistration.js